<template>
  <div>
    <b-modal
      ref="my-modal"
      centered
      size="sm"
      hide-footer
      hide-header
      no-close-on-backdrop
      title="Using Component Methods"
    >
      <a
        class="btn-close"
        @click="hideModal"
      >
        <img
          :src="require('@/assets/images/close.png')"
          alt=""
        >
      </a>
      <div class="modal-text mb-1">
        <h4 class="mb-2">
          Input Your Bid Amount
        </h4>
        <div class="d-flex flex-wrap w-100">
          <b-col md="6">
            <p class="text-header">
              Channel</p>
          </b-col>
          <b-col md="6">
            <p
              class="text-child text-md-right"
            >
              {{ dataReview.channel_name }}</p>
          </b-col>
          <b-col md="6">
            <p class="text-header">
              Buy Method</p>
          </b-col>
          <b-col md="6">
            <p class="text-child text-md-right">
              {{ dataReview.method_name }}</p>
          </b-col>
          <b-col md="6">
            <p class="text-header">
              Select Your Campaign ID</p>
          </b-col>
          <b-col md="6">
            <p
              v-if="datas.campaign_id === null"
              class="text-child text-md-right text-primary font-weight-bolder"
            >
              <a @click="showModalCampaign">Select</a>
            </p>
            <p
              v-if="datas.campaign_id !== null"
              class="text-child text-md-right"
            >
              {{ datas.campaign_id }}
              <a
                class="text-primary font-weight-bolder"
                @click="showModalCampaign"
              ><feather-icon
                icon="EditIcon"
                class="ml-50"
              />
              </a>
            </p>
          </b-col>
          <b-col md="6">
            <p class="text-header">
              Current Highest Bid</p>
          </b-col>
          <b-col md="6">
            <p class="text-child text-md-right">
              {{ formatPrice(dataReview.highest_bid) }} </p>
          </b-col>
          <b-col md="12">
            <v-select
              id="bidprice"
              v-model="datas.bid_percentage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="bidprices"
              :reduce="text => text.value"
              label="text"
              @input="setBidPrice"
            />
          </b-col>
          <b-col md="6">
            <p class="text-header text-success mt-1">
              Your Bid</p>
          </b-col>
          <b-col md="6">
            <p class="text-child text-md-right font-medium-4 font-weight-bolder mt-1 text-primary">
              {{ formatPrice(bidPrice) }} </p>
          </b-col>
        </div>
        <div class="d-flex justify-content-center container-button mt-2">
          <b-button
            block
            :disabled="(datas.campaign_id === null) ? true : false"
            variant="primary"
            @click="actionSubmit"
          >
            <span class="align-middle">Submit</span>
            <feather-icon
              icon="CheckCircleIcon"
              class="ml-50"
            />
          </b-button>
        </div>
      </div>
    </b-modal>
    <popup-campaign-list
      ref="campaignPopup"
      @selectCampaign="setCampaignId"
    />
  </div>
</template>

<script>
import {
  BModal,
  BButton,
  BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  mapActions, mapGetters,
} from 'vuex'
import PopupCampaignList from '@/views/component/PopupCampaignList.vue'

export default {
  components: {
    BModal,
    BButton,
    BCol,
    vSelect,
    PopupCampaignList,
  },
  // props: {
  //   dataReview: {
  //     default: () => {},
  //     type: Object,
  //   },
  // },
  data() {
    return {
      selected: [],
      bidPrice: 0,
      datas: this.$store.state.auction.dataSend,
      dataReview: {},
    }
  },
  computed: {
    // ...mapState('account', [
    //   'reason',
    // ]),
    ...mapGetters('datas', {
      channel: 'getChannel',
      methodBuy: 'getBuyMethod',
      bidprices: 'getBidPrice',
    }),
    listReason: {
      get() {
        return this.reason
      },
      set(val) {
        this.setReason(val)
      },
    },
  },
  methods: {
    ...mapActions('auction', [
      'submitBidding',
      'getDataBidding',
    ]),
    // ...mapMutations('account', {
    //   setReason: 'SET_REASON',
    // }),
    actionSubmit() {
      // this.setReason(this.selected)
      this.submitBidding().then(res => {
        if (res.status) {
          // this.hideModal()
          this.success()
        } else {
          this.failed()
        }
      }, error => {
        console.error('err', error)
      })
    },
    setDataReview(item) {
      this.dataReview = item
    },
    success() {
      this.$swal({
        title: 'Your bid has been submitted',
        text: 'Thank you, your bid is being processed. Your campaign will run based on selected time.',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      }).then(result => {
        if (result.value) {
          this.hideModal()
          this.getDataBidding()
          // const routeName = this.$route.matched[0].path
          // this.$router.push({ path: '/auction' })
        }
      })
    },
    failed() {
      this.$swal({
        title: 'Failed!',
        text: '',
        icon: 'Warning',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
      })
      // .then(result => {
      //   if (result.value) {
      //     const routeName = this.$route.matched[0].path
      //     this.$router.push({ path: `${routeName}/approval` })
      //   }
      // })
    },
    showModal() {
      this.$store.state.auction.dataSend.campaign_id = null
      this.$store.state.auction.dataSend.hour = this.dataReview.hour
      this.$store.state.auction.dataSend.bid_percentage = 1
      this.setBidPrice(1)
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    showModalCampaign() {
      this.$refs.campaignPopup.showModal()
    },
    hideModalCampaign() {
      this.$refs.campaignPopup.hideModal()
    },
    formatPrice(value) {
      if (value === null || typeof value === 'undefined') {
        return 0
      }
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    setBidPrice(val) {
      let hiBid = parseInt(this.dataReview.highest_bid, 10)
      let totalBid = ((val / 100) * hiBid) + hiBid
      this.bidPrice = Math.round(totalBid)
      // console.log(val, this.dataReview, totalBid)
    },
    setCampaignId(id) {
      this.datas.campaign_id = id
      // console.log(id, this.datas.campaign_id)
    },
    // actionSubmit() {
    //   console.log(this.datas)
    // },
  },
}
</script>
<style scoped>
.btn-close {
  position: absolute !important;
  right: 18px;
  top: 14px;
}
.img-success-register {
  margin-top: 43px;
}
.modal-text {
  text-align: left;
  font-family: 'Rubik';
  margin-top: 5px;
}

.modal-text > h4 {
  font-weight: bold;
  color: #000;
  margin-bottom: 0;
}

.modal-text > p {
  margin-top: 15px;
}
.text-header {
  font-size: 1rem;
  font-weight: 800;
}
</style>
